export const ValidationType = {
	VALIDATE_ON_SEARCH_REQUEST: "validateOnSearchRequest",
	VALIDATE_IMMEDIATELY: "validateImmediately",
};

export class ValidationRule {
	constructor(rule, validateOn = ValidationType.VALIDATE_IMMEDIATELY) {
		this.rule = rule;
		this.validateOn = validateOn;
	}

	getValidationRule() {
		return this.rule;
	}

	isValidatedImmediately() {
		return this.validateOn === ValidationType.VALIDATE_IMMEDIATELY;
	}
}
